var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_255",
  "data-name": "Grupo 255",
  transform: "translate(-1471 -665)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_31",
  "data-name": "Elipse 31",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(1471 665)",
  fill: "#eee9ff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_253",
  "data-name": "Grupo 253",
  transform: "translate(1477.75 671.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_472",
  "data-name": "Caminho 472",
  d: "M12,14.647H10.128a2.253,2.253,0,0,1-2.21-2.292.558.558,0,0,1,1.116,0,1.139,1.139,0,0,0,1.094,1.176H12a.928.928,0,0,0,.886-.953c0-.647-.231-.774-.61-.908l-3-1.057A1.862,1.862,0,0,1,7.91,8.649a2.037,2.037,0,0,1,2-2.069H11.78a2.253,2.253,0,0,1,2.21,2.292.558.558,0,1,1-1.116,0A1.139,1.139,0,0,0,11.78,7.7H9.912a.928.928,0,0,0-.886.953c0,.647.231.774.61.908l3,1.057A1.862,1.862,0,0,1,14,12.578,2.046,2.046,0,0,1,12,14.647Z",
  transform: "translate(-1.704 -1.363)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_473",
  "data-name": "Caminho 473",
  d: "M11.808,15.3a.562.562,0,0,1-.558-.558V5.808a.558.558,0,1,1,1.116,0v8.93A.562.562,0,0,1,11.808,15.3Z",
  transform: "translate(-2.558 -1.023)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_474",
  "data-name": "Caminho 474",
  d: "M11.483,17.25H7.017c-4.041,0-5.767-1.727-5.767-5.767V7.017c0-4.041,1.727-5.767,5.767-5.767h4.465c4.041,0,5.767,1.727,5.767,5.767v4.465C17.25,15.523,15.523,17.25,11.483,17.25ZM7.017,2.366c-3.431,0-4.651,1.22-4.651,4.651v4.465c0,3.431,1.22,4.651,4.651,4.651h4.465c3.431,0,4.651-1.22,4.651-4.651V7.017c0-3.431-1.22-4.651-4.651-4.651Z",
  transform: "translate(0 0)",
  fill: "#db56e0"
})))));
export default __webpack_public_path__ + "static/media/money_active.e3367a44.svg";
export { SvgComponent as ReactComponent };